"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = require("./colors");

var typography = {
  body1: {
    color: _colors.opacity.black[87],
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '20px'
  },
  body2: {
    color: _colors.opacity.black[54],
    fontFamily: '"Roboto Mono", "Helvetica", "Arial", sans-serif',
    fontSize: '13px',
    fontWeight: 400,
    letterSpacing: '0px',
    lineHeight: '20px'
  },
  button: {
    color: _colors.opacity.black[87],
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: '0.5px',
    lineHeight: '16px',
    textTransform: 'uppercase'
  },
  caption: {
    color: _colors.opacity.black[87],
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px'
  },
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontSize: 13,
  fontWeightLight: 300,
  fontWeightMedium: 500,
  fontWeightRegular: 400,
  h1: {
    color: _colors.opacity.black[87],
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: '112px',
    fontWeight: 400,
    letterSpacing: '-4px',
    lineHeight: '132px',
    marginLeft: '-.04em'
  },
  h2: {
    color: _colors.opacity.black[87],
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: '56px',
    fontWeight: 400,
    lineHeight: '66px',
    marginLeft: '-.02em'
  },
  h3: {
    color: _colors.opacity.black[87],
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: '45px',
    fontWeight: 400,
    lineHeight: '48px',
    marginLeft: '-.02em'
  },
  h4: {
    color: _colors.opacity.black[87],
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: '34px',
    fontWeight: 400,
    lineHeight: '40px'
  },
  h5: {
    color: _colors.opacity.black[87],
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '32px'
  },
  h6: {
    color: _colors.opacity.black[87],
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '28px'
  },
  overline: {
    color: _colors.opacity.black[60],
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: 'normal',
    lineHeight: '14px',
    textTransform: 'none'
  },
  subtitle1: {
    color: _colors.opacity.black[87],
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: '15px',
    fontWeight: 400,
    lineHeight: '20px'
  },
  useNextVariants: true
};
var _default = typography;
exports["default"] = _default;